import React, { Component } from 'react'
import PropTypes from 'prop-types'

import InternalReviewBox from './InternalReviewBox'

import { experience, subject, copy } from '../../../../utils/messages'
import { findApproval } from '../../../../utils/approval'

export default class InternalReviewBoxes extends Component {
  render() {
    const boxes = [experience, subject, copy].map((type, index) => {
      return (
        <InternalReviewBox
          type={type}
          key={index}
          approval={findApproval(
            this.props.approvals,
            type.props.defaultMessage.toLowerCase()
          )}
          {...this.props}
        />
      )
    })

    return <div className="internal-review-box-container">{boxes}</div>
  }
}

InternalReviewBoxes.propTypes = {
  user: PropTypes.object.isRequired,
  quest: PropTypes.object.isRequired,
  organization: PropTypes.object.isRequired,
  handleAssignClick: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  approvals: PropTypes.array,
  toQualityReviewModalIsOpen: PropTypes.bool.isRequired,
  isEditingApproval: PropTypes.bool.isRequired
}



// WEBPACK FOOTER //
// ./src/components/quest/review/internalreview/InternalReviewBoxes.js